import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-currentplan-changeplan',
  templateUrl: './currentplan-changeplan.component.html',
  styleUrls: ['./currentplan-changeplan.component.sass']
})
export class CurrentplanChangeplanComponent implements OnInit {
  @Input() index;
  @Input() currentPlan;
  @Input() quota_val;
  @Input() actualPrice;
  @Input() plan_desc;
  @Input() plac_eq;
  @Input() add_serv;
  @Input() equ_instal;
  @Input() desc_equ;
  @Input() plan_type;

  constructor() { }

  ngOnInit() {
  }

}
